import { createIcon, FlameIcon } from '@root/shared/ui-kit'

import { OTHER_RANK_COLOR, RANK_COLOR } from './constants'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  rank: number
  size?: number
} & ClassNameProps

export const PairRankIcon: React.FC<Props> = ({ rank, size = 14 }) => {
  if (rank > 10) {
    return undefined
  }

  if (rank === 1) {
    return <FirstRankIcon size={size} />
  }

  return (
    <FlameIcon
      style={{ color: RANK_COLOR[rank] ?? OTHER_RANK_COLOR }}
      size={size}
    />
  )
}

const FirstRankIcon = createIcon(
  <>
    <path
      d="M10 11.5L8.5 13L7 13.5H5.5L3 11V9L4.5 6.5L6.5 6L8 7.5L10 8.5V11.5Z"
      fill="#F6C916"
    />
    <path
      d="M10.8451 5.31357C10.8073 5.26626 10.7615 5.27556 10.7375 5.28521C10.7174 5.29336 10.6714 5.31939 10.6778 5.38463C10.6854 5.46297 10.6897 5.54284 10.6905 5.62206C10.694 5.95068 10.5621 6.27262 10.3289 6.50534C10.0971 6.73656 9.7923 6.86114 9.46773 6.85753C9.02438 6.85187 8.65666 6.62063 8.4043 6.18879C8.19564 5.8317 8.28735 5.37115 8.38445 4.88353C8.44127 4.59812 8.50003 4.30297 8.50003 4.02207C8.50003 1.83487 7.02965 0.573009 6.15317 0.0154976C6.13504 0.00398584 6.11779 -6.10352e-05 6.1025 -6.10352e-05C6.07765 -6.10352e-05 6.05796 0.0106577 6.04825 0.0172202C6.02944 0.0299624 5.99934 0.0590015 6.00902 0.110408C6.34403 1.88945 5.34478 2.95943 4.28685 4.09223C3.19638 5.25989 1.96042 6.58336 1.96042 8.97025C1.96042 11.7437 4.21674 14 6.99017 14C9.2737 14 11.287 12.4079 11.8862 10.1284C12.2948 8.57409 11.8666 6.59418 10.8451 5.31357ZM7.11565 12.9264C6.42117 12.9581 5.76071 12.709 5.25624 12.2266C4.75719 11.7494 4.47096 11.0835 4.47096 10.3995C4.47096 9.11596 4.96172 8.1737 6.28172 6.92277C6.30332 6.90229 6.32544 6.89581 6.34472 6.89581C6.36219 6.89581 6.37734 6.90115 6.38775 6.90615C6.40971 6.91673 6.44581 6.94293 6.44094 6.99958C6.39374 7.54878 6.39456 8.00463 6.44334 8.35452C6.56803 9.24825 7.22229 9.84875 8.07145 9.84875C8.48778 9.84875 8.88435 9.69207 9.18811 9.40756C9.22336 9.37452 9.26273 9.37874 9.27783 9.38193C9.29781 9.38625 9.32458 9.39851 9.33861 9.43233C9.46456 9.73642 9.52892 10.0592 9.52991 10.3917C9.53393 11.7295 8.4509 12.8666 7.11565 12.9264Z"
      fill="#F61616"
    />
  </>,
  '0 0 14 14',
)
